import React, { useContext } from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { MainRoutes } from '../models';
import { BaseContext } from '../base-context';
import { Tooltip } from './Tooltip';

interface FAQHelpIconProps {
  anchor?: string;
  className?: string;
  size?: 'sm' | 'md';
  tooltipText?: string;
}

export const FAQHelpIcon: React.FC<FAQHelpIconProps> = ({
  anchor,
  className,
  size = 'sm',
  tooltipText = 'View FAQ',
}) => {
  const navigate = useNavigate();
  const { setIsSidebarShown } = useContext(BaseContext);

  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsSidebarShown(false);
    const path = anchor ? `${MainRoutes.FAQ}#${anchor}` : MainRoutes.FAQ;
    navigate(path);
  };

  return (
    <Tooltip content={tooltipText} placement="top">
      <button
        onClick={handleClick}
        className={`inline-flex items-center justify-center text-muted-foreground hover:text-primary transition-colors focus:outline-none rounded-full ${className || ''}`}
        aria-label="View FAQ"
      >
        <QuestionMarkCircleIcon className={sizeClasses[size]} />
      </button>
    </Tooltip>
  );
};
